import {useLocation} from "react-router";
import {Page} from "../PageDescriptors";
import {FormattedMessage} from "react-intl";
import {useAuth} from "@/context/AuthProvider";
import {Link} from "react-router";
import {Fade, List, ListItemButton, useTheme} from "@mui/material";

const itemPadding = 16;
const arrowSize = 10;

function SidebarItem({basePath, page, locationPath}: {basePath: string; page: Page; locationPath: string}) {
    const theme = useTheme();
    const auth = useAuth();
    let hide: boolean = false;

    if (page.hideHook) {
        hide = page.hideHook(auth);
    }

    if (hide) return null;

    if (page.permission && !auth.hasPermission(page.permission)) return null;

    const path = basePath == "/" ? "/" + page.path : basePath + "/" + page.path;
    const selected = path === locationPath.replace(/\/$/, "");

    return (
        <ListItemButton selected={selected} key={path} component={Link} to={path} style={{paddingRight: itemPadding}}>
            <div style={{display: "flex", width: "100%", alignItems: "center"}}>
                <span style={{flexGrow: 1}}>
                    <FormattedMessage {...page.label} />
                </span>
                <Fade in={selected}>
                    <div
                        style={{
                            borderTop: `${arrowSize}px solid transparent`,
                            borderBottom: `${arrowSize}px solid transparent`,
                            borderRight: `${arrowSize}px solid ${theme.palette.background.default}`,
                            height: arrowSize,
                            marginRight: -itemPadding,
                        }}
                    />
                </Fade>
            </div>
        </ListItemButton>
    );
}

/// generic sidebar for a page with children
export function PageSidebar({basePath, page}: {basePath: string; page: Page}) {
    const location = useLocation();

    if (!page.items) return null;

    return (
        <List>
            {...page.items.map((item) => (
                <SidebarItem key={item.path} basePath={basePath} page={item} locationPath={location.pathname} />
            ))}
        </List>
    );
}
